import React, { Component } from "react";
import PropTypes from "prop-types";

import { Alert, Card, CardBody, Col, Container, Row, Label } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

// actions
import { apiError, loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";
import lightlogo from "../../assets/images/logo-light.svg";
import API from "helpers/api_helper";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: "",
      loading: false,
    };
  }

  componentDidMount() {}

  handleSubmit = async values => {
    const { history } = this.props;
    this.setState({ loading: true });
    console.log(values);

    try {
      const res = await API.common.auth.getToken(values);
      if (!!res.status) {
        history.push("/two-step-verification", { ...values });
      } else {
        throw res.message;
      }
    } catch (error) {
      this.setState({ loading: false });
      console.log("ERROR CODE 1 : ", error);
    }
  };

  render() {
    const { mobile } = this.state;
    return (
      <React.Fragment>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2" />
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">خوش آمدید !</h5>
                          <p>برای ادامه وارد خانه من شوید</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div className="auth-logo">
                      <Link to="/" className="auth-logo-light">
                        <div className="avatar-md profile-user-wid mb-4">
                          <img src="/logo192.png" alt="" width="154" />
                        </div>
                      </Link>
                      <Link to="/" className="auth-logo-dark">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      {this.props.error && this.props.error ? (
                        <Alert color="danger">{this.props.error}</Alert>
                      ) : null}

                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          mobile: mobile,
                        }}
                        validationSchema={Yup.object().shape({
                          mobile: Yup.number().required(
                            "لطفا شماره همراه خود را وارد کنید"
                          ),
                        })}
                        onSubmit={this.handleSubmit}
                      >
                        {({ errors, status, touched }) => (
                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label for="email" className="form-label">
                                شماره همراه
                              </Label>
                              <Field
                                name="mobile"
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.mobile && touched.mobile
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="mobile"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>

                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customControlInline"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="customControlInline"
                              >
                                من را بخاطر بسبار
                              </label>
                            </div>

                            {this.state.loading ? (
                              <div className="mt-3 d-grid">
                                <button
                                  className="btn btn-primary btn-block"
                                  type="button"
                                  disabled
                                >
                                  درحال انجام عملیات{" "}
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle" />
                                </button>
                              </div>
                            ) : (
                              <div className="mt-3 d-grid">
                                <button
                                  className="btn btn-primary btn-block"
                                  type="submit"
                                >
                                  وارد شوید
                                </button>
                              </div>
                            )}
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
};

const mapStateToProps = state => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
);
